<template>
    <v-snackbar v-model="notifier" max-width="500" persistent>
        {{ notification.message }}
        <v-btn color="indigo" text @click="notifier = false">
            Close
        </v-btn>
    </v-snackbar>
</template>
<script>
import {
    CLEAR_NOTIFICATIONS
} from "@/store/actions.type"

export default {

    data: () => ({
       // notifier: false
    }),

    methods: {
        clearNotification() {
            this.$store.dispatch(CLEAR_NOTIFICATIONS)
        }
    },

    computed: {
        notification() {
            return this.$store.state.common.notification
        },

        notifier: {
            get() {
                return this.$store.state.common.notification.message
            },
            set(val) {
                if(!val) this.$store.dispatch(CLEAR_NOTIFICATIONS)
            }
        }
    }
}
</script>